<template>
    <div class="col-12 my-2">
        <div class="row">
            <div class="col-12">
                <h2 class="mb-4">Confirm your name and signature</h2>
            </div>
        </div>

        <div class="d-flex align-items-center">
            <div class="amb-table-check-container">
                <input class="table-checkbox" type="checkbox" id="check-1" v-model="agree"/>
                <span class="amb-table-checkmark"></span>
            </div>
            <label class="ml-2 mb-0" for="check-1">
                <strong>
                    I agree and confirm that I have read and understood all pages within this document and agree to the
                    <a
                        href="#"
                        @click="openStatement"
                        style="color:#2377bd;"
                    >ELECTRONIC RECORD AND SIGNATURE DISCLOSURE</a> terms and conditions.
                </strong>
            </label>
        </div>
        <div class="card mt-3" id="sign-pad">
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-12 col-md-6 mb-3">
                        <label for style="font-weight: bold;">Enter Name Here</label>
                        <input
                            type="text"
                            class="form-control"
                            id="name"
                            v-model="applicant.full_name"
                            v-if="applicant"
                        />
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <label for style="font-weight: bold;">Date</label>
                        <input type="text" class="form-control" id="date" v-model="date" readonly/>
                    </div>
                </div>
            </div>
        </div>

        <!-- <signature-statement :open.sync="openStatement" :statement="statement"></signature-statement> -->
    </div>
    <!-- end step 4 -->
</template>
<script>
export default {
    props: {
        signature: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            applicant: null,
            agree: false,
            date: this.$moment(new Date()).format("DD/MM/YYYY")
        };
    },
    mounted() {
        this.applicant = this.signature.applicant ? this.signature.applicant : this.signature.user;
        this.applicant.full_name = `${this.applicant.first_name} ${this.applicant.last_name}`;
    },
    methods: {
        openStatement() {
            window.dispatchEvent(new Event("openStatement"));
        }
    },
    watch: {
        agree(newVal, oldVal) {
            this.$emit("verified", newVal);
        }
    }
};
</script>
